import {BlockElements, ListBlocks} from 'TemplateEditor/Layout/Blocks'
import type {Padding} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'
import {SectionConfigType} from 'TemplateEditor/Layout/Sections/SectionConfig'
import {SubSectionConfigType} from 'TemplateEditor/Layout/Sections/SubSectionConfig'

/** Default paddings applied when adding new sections/columns/blocks from the palette. */
export type TemplateDefaultPaddingStorage = {
  section?: Padding
  column?: Padding
  block?: Padding
  /** Falls back to `block` when unset for new blocks. */
  blockMobile?: Padding
}

export type Template = {
  sections?: Section[]
  defaultPadding?: TemplateDefaultPaddingStorage
}

const allTypes = ListBlocks.map((ListBlock) => ListBlock.typeId)
export type BlockTypes = (typeof allTypes)[number]

export type Section = SectionConfigType & {
  id: string
  type: string
  blocks: {
    [position: number]: BlockElements[]
  }
  innerStyles: {
    [position: number]: SubSectionConfigType
  }
}

export type Block = {
  id: string
  type: BlockTypes
}

export const DefaultTemplate: Template = {
  sections: [],
}
